export default "__VITE_ASSET__NXOb88E0__"